import { useState, useEffect, useMemo, useCallback, useRef } from "react";

import * as Material from "@mui/material";

import LandscapeIcon from "@mui/icons-material/Landscape";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import { useChallenge } from "../../contexts/ChallengeContext";

const SelectChallenge = () => {
  const { loading, handleOpenChallengesSelect, currentChallenge } =
    useChallenge();

  return (
    <>
      {!loading && (
        <>
          <Material.Tooltip title="Alterar comunidade" arrow>
            <a
              className="select-challenge"
              onClick={handleOpenChallengesSelect}
            >
              {currentChallenge?.banner ? (
                <img
                  src={currentChallenge?.banner}
                  className="challenge-banner"
                />
              ) : (
                <LandscapeIcon className="challenge-banner" />
              )}
              <div style={{ flexGrow: 1 }}>
                <small>Comunidade</small>

                <h5>{currentChallenge?.name}</h5>
              </div>
              <ArrowDropDownIcon />
            </a>
          </Material.Tooltip>
        </>
      )}
    </>
  );
};

export default SelectChallenge;
